/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateProjectVideoEditorProjectsMutationRequest, CreateProjectVideoEditorProjectsMutationResponse } from "../models/CreateProjectVideoEditorProjects";

export function getCreateProjectVideoEditorProjectsUrl() {
  const res = { method: 'POST', url: `/video-editor/projects` as const }
  return res
}

/**
 * @summary Create a project from a source (response includes creator and published platforms)
 * {@link /video-editor/projects}
 */
export async function createProjectVideoEditorProjects(data: CreateProjectVideoEditorProjectsMutationRequest, config: Partial<RequestConfig<CreateProjectVideoEditorProjectsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, CreateProjectVideoEditorProjectsMutationRequest>({ method : "POST", url : getCreateProjectVideoEditorProjectsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}